import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { StyledFlyover } from './Flyover.styled';
import { FlyoverBuilder } from './FlyoverBuilder';
export function Flyover(props) {
  var ProvidedFlyover = props.flyover;
  var renderFlyover = typeof ProvidedFlyover === 'function' ? ProvidedFlyover : function (_) {
    return ProvidedFlyover;
  };
  return /*#__PURE__*/React.createElement(FlyoverBuilder, _extends({}, props, {
    flyover: function flyover(flyoverProps) {
      return /*#__PURE__*/React.createElement(StyledFlyover, null, renderFlyover(flyoverProps));
    }
  }));
}